export const resolveReservationEventName = (accommodationCode) => (
  accommodationCode ? 'display-user-info-koedia' : 'display-user-info'
);

export const normalizeTariffSelection = (selectedTariffs) => {
  if (Array.isArray(selectedTariffs)) return selectedTariffs;
  if (selectedTariffs) return [selectedTariffs];
  return [];
};

export const toMoney = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const generateReservationTrackingId = () => {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();

  return `ospita-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
};

export const ensureOspitaTrackingId = () => {
  let state = {};

  try {
    state = JSON.parse(localStorage.getItem('reservationState') || '{}') || {};
  } catch (error) {
    state = {};
  }

  if (!state.ospita_tracking_id) {
    state.ospita_tracking_id = generateReservationTrackingId();
    localStorage.setItem('reservationState', JSON.stringify(state));
  }

  return state.ospita_tracking_id;
};

export const readOspitaTrackingId = () => {
  try {
    const state = JSON.parse(localStorage.getItem('reservationState') || '{}') || {};
    return state.ospita_tracking_id || null;
  } catch (error) {
    return null;
  }
};

export const withOspitaTrackingId = (state = {}) => ({
  ...state,
  ospita_tracking_id: state.ospita_tracking_id || ensureOspitaTrackingId(),
});

export const normalizeChildAges = (ages) => {
  if (!Array.isArray(ages)) return [];

  return ages
    .map((age) => age?.toString?.().trim?.() ?? '')
    .filter((age) => age !== '');
};

export const normalizeRoomPlan = (plan = {}) => {
  const childrenAges = normalizeChildAges(plan.children_ages);

  return {
    room_count: Number(plan.room_count) > 0 ? Number(plan.room_count) : 1,
    adults: Math.max(0, parseInt(plan.adults, 10) || 0),
    children: Number(plan.children) >= 0 ? Number(plan.children) : childrenAges.length,
    children_ages: childrenAges,
  };
};

export const normalizeRoomPlans = (roomPlans) => {
  if (!Array.isArray(roomPlans)) return [];
  return roomPlans.map(normalizeRoomPlan);
};

export const expandRoomPlans = (roomPlans) => (
  normalizeRoomPlans(roomPlans).flatMap((plan) => {
    const roomCount = Number(plan.room_count) > 0 ? Number(plan.room_count) : 1;

    return Array.from({ length: roomCount }, () => ({
      room_count: 1,
      adults: plan.adults,
      children: plan.children,
      children_ages: [...plan.children_ages],
    }));
  })
);

export const deriveGuestStateFromRoomPlans = (roomPlans) => {
  const expandedPlans = expandRoomPlans(roomPlans);

  const adults = expandedPlans.reduce((sum, plan) => sum + (parseInt(plan.adults, 10) || 0), 0);
  const childAges = expandedPlans.flatMap((plan) => normalizeChildAges(plan.children_ages));

  return {
    adults,
    childs: childAges.length,
    children_ages: childAges,
  };
};

export const normalizeReservationSelectionPayload = (payload = {}) => {
  const selectedTariffsInput = normalizeTariffSelection(
    payload.selectedTariffs || payload.selectedTariff
  );

  return {
    selectedTariffsInput,
    cartTotal: toMoney(payload.cartTotal),
    accommodation_code: payload.accommodation_code || null,
    koediaSessionId: payload.koediaSessionId || null,
    selected_rooms: Array.isArray(payload.selected_rooms) ? payload.selected_rooms : [],
    room_plans: normalizeRoomPlans(payload.room_plans),
    room_count: Number(payload.room_count) > 0 ? Number(payload.room_count) : null,
  };
};
